// dates.ts - 날짜 순수 헬퍼. 로컬 필드만 사용한다.
// (toISOString() 은 UTC 라 KST 자정~09시 사이 하루가 밀린다.)
// "오늘" 기준 동작은 컴포넌트 경계에서 만든 Date 를 인자로 받아 여기서 계산한다.

export function isoDate(d: Date): string {
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

export function addDays(d: Date, days: number): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + days);
  return out;
}

// 두 ISO 날짜("YYYY-MM-DD") 사이의 일수 차 - b - a. 시간대 무시(로컬 자정 기준).
export function daysBetween(aIso: string, bIso: string): number {
  const a = parseIsoDate(aIso);
  const b = parseIsoDate(bIso);
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}

// ISO 날짜 문자열 → 로컬 자정 Date. new Date("2026-01-02") 는 UTC 자정으로 파싱돼
// KST 에서 하루 밀리므로 직접 필드를 쪼갠다.
export function parseIsoDate(iso: string): Date {
  const [y, m, d] = iso
    .slice(0, 10)
    .split("-")
    .map((s) => Number.parseInt(s, 10));
  return new Date(y, m - 1, d);
}

// 최근 n개월 필터 옵션 - 이번 달부터 역순. value "YYYY-MM", label "YYYY년 M월".
export function recentMonths(d: Date, n: number): { value: string; label: string }[] {
  return Array.from({ length: n }, (_, i) => {
    const m = new Date(d.getFullYear(), d.getMonth() - i, 1);
    return {
      value: `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, "0")}`,
      label: `${m.getFullYear()}년 ${m.getMonth() + 1}월`,
    };
  });
}

const WEEKDAY_KO = ["일", "월", "화", "수", "목", "금", "토"] as const;

/** ISO 날짜의 한국어 요일 1글자. */
export function weekdayKo(iso: string): string {
  return WEEKDAY_KO[parseIsoDate(iso).getDay()];
}

/**
 * 목록 화면 헤더의 기준일 표기 (결정 S-14).
 * 상태·D-Day 가 KST 오늘에 의존하므로 기준일이 보여야 값을 신뢰할 수 있다.
 */
export function asOfLabel(iso: string): string {
  return iso ? `${iso} (${weekdayKo(iso)}) 기준` : "";
}

/** `MM/DD`. §4-2 / §11 / §13 의 좁은 날짜 셀 표기. */
export function monthDay(iso: string): string {
  return iso ? `${iso.slice(5, 7)}/${iso.slice(8, 10)}` : "";
}

/** `YYYY.MM.DD`. §12 상세화면 헤더의 SOP 표기. */
export function dotDate(iso: string): string {
  return iso ? iso.split("-").join(".") : "";
}
